export enum EventHandlingMessage {
    CreateHighlight = 'CREATE_HIGHLIGHT',
}

export interface IHighlightOptions {
}
